import { Status } from 'redux/types/state.interface';

export type Language = {
  definition: string;
  acronym: string;
  icon: string;
};

export type AllCountry = {
  definition: string;
  acronym: string;
  icon: string;
};

export enum Countries {
  CA = 'https://www.ediblearrangements.ca/',
  USA = 'https://www.ediblearrangements.com/',
  UAE = 'https://www.ediblearrangements.ae/',
  QA = 'https://www.ediblearrangements.qa/ ',
}
export enum Languages {
  ENGLISH = 'en-us',
  FRENCH = 'fr-ca',
}

export type LocaleState = {
  data: string;
  status: Status | null;
};

export enum CultureChangeStatus {
  OK = 'OK',
  Error = 'Error',
}

export type CultureChangeResponse = {
  _Status?: CultureChangeStatus;
  _Data?: CultureChangeStatus;
};
